import { useState } from "react";
import { Anchor, H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";
import CreatableSelect from "react-select/creatable";
import { validateArray } from "../../utils/validate";

const InputDocumentsDataAdd = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });
  const {
    data: document,
    loading: loadDocument,
    call: callDocument,
  } = Request({
    urlApi: field.urlApi,
  });

  function handleForm(item) {
    openDialog(
      <>
        {loadDocument && (
          <FormAddDocument
            data={document}
            item={item}
            reload={call}
            field={field}
            onClose={dialogClose}
            callDocument={callDocument}
          />
        )}
        <br />
      </>
    );
  }

  function handleDelete(data) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        {loadDocument && (
          <FormAddDocument
            data={document}
            reload={call}
            field={field}
            onClose={() => {}}
            callDocument={callDocument}
          />
        )}
      </div>
      <br />
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Campo",
              },
              {
                name: "description",
                label: "Numero",
              },
              {
                name: "description4",
                label: "Cantidades",
                type: "custom",
                builder: (item) => {
                  try {
                    const origData = JSON.parse(item || "{}");
                    return (
                      <div className="text-xs">
                        {Object.entries(origData).map(([key, val]) => (
                          <div key={key}>
                            {key}: {val}
                          </div>
                        ))}
                      </div>
                    );
                  } catch {
                    return "-";
                  }
                },
              },
              {
                name: "description2",
                label: "Fech.Recep.",
                type: "date",
              },
              {
                name: "description3",
                label: "Obs.",
              },
              {
                name: "creationDate",
                label: "Fecha / hora",
                type: "date",
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar",
                    icon: "fas  fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Añadir",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddDocument = (props) => {
  const { data, item = null, reload, field, onClose, callDocument } = props;

  // Parsear los valores existentes de Description4 si existen
  const parseOrigData = (description4) => {
    try {
      return description4
        ? JSON.parse(description4)
        : {
            Orig: 0,
            Cop: 0,
            Fot: 0,
            Dig: 0,
            Otro: 0,
          };
    } catch {
      return {
        Orig: 0,
        Cop: 0,
        Fot: 0,
        Dig: 0,
        Otro: 0,
      };
    }
  };

  const initialOrigData = parseOrigData(item?.description4);

  const [values, setValues] = useState({
    Label: item?.label ? item.label : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
    Description: item?.description ? item.description : "",
    Description2: item?.description2 ? item.description2 : "",
    Description3: item?.description3 ? item.description3 : "",
    // Ahora Description4 será un objeto stringificado
    Description4: item?.description4
      ? item.description4
      : JSON.stringify({
          Orig: 0,
          Cop: 0,
          Fot: 0,
          Dig: 0,
          Otro: 0,
        }),
    isNew: false,
  });

  const [origData, setOrigData] = useState(initialOrigData);
  const [load, setLoad] = useState(false);

  // Configuración de los campos de cantidades
  const origFields = [
    { key: "Orig", label: "Originales" },
    { key: "Cop", label: "Copias" },
    { key: "Fot", label: "Fotocopias" },
    { key: "Dig", label: "Digitales" },
    { key: "Otro", label: "Otros" },
  ];

  async function handleSubmit() {
    setLoad(true);

    // Convertir el objeto origData a string para guardar en Description4
    const valuesToSubmit = {
      ...values,
      Description4: JSON.stringify(origData),
    };

    if (values.isNew) {
      await handleCreateOption(values);
    }

    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      valuesToSubmit
    )
      .then(() => {
        setLoad(false);
        reload();
        onClose();
        setValues({
          ...values,
          Label: "",
          NumberValue: 0,
          Description: "",
          Description2: "",
          Description3: "",
          Description4: JSON.stringify({
            Orig: 0,
            Cop: 0,
            Fot: 0,
            Dig: 0,
            Otro: 0,
          }),
        });
        setOrigData({
          Orig: 0,
          Cop: 0,
          Fot: 0,
          Dig: 0,
          Otro: 0,
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        setLoad(false);
        toast.error("Se produjo un error al guardar");
      });
  }

  async function handleCreateOption(value) {
    await requestAuth("post", "/Dropdown/Option", {
      Name: value.Label,
      DropdownListLabel: field.urlInitial,
    }).then(() => {
      callDocument();
    });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((a) => ({
      ...a,
      [name]: value,
    }));
  }

  // Manejar cambios en los campos de cantidades
  function handleOrigChange(e, key) {
    const value = parseInt(e.target.value) || 0;
    setOrigData((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  function handleChange(e) {
    setValues((a) => ({
      ...a,
      Label: e?.value ? e.value : "",
      isNew: e?.__isNew__ || false,
    }));
  }

  return (
    <form className={`flex flex-col ${item ? "max-w-lg" : ""}`}>
      <Label className={`mt-2`}>Lista de campos</Label>
      <CreatableSelect
        isSearchable={true}
        isClearable={true}
        onChange={handleChange}
        styles={{
          placeholder: (base) => ({
            ...base,
            color: "black",
          }),
        }}
        defaultValue={{
          value: values.Label,
          label: values.Label,
        }}
        placeholder={"Seleccionar..."}
        isOptionSelected={false}
        options={data.map((option) => ({
          value: option.name,
          label: option.name,
        }))}
      />

      <Label className={`my-0 mt-2`}>Numero</Label>
      <input
        value={values.Description}
        onChange={handleChangeInp}
        className="w-full p-2 rounded-md"
        type="text"
        name="Description"
      />

      <Label className={`my-0 mt-2`}>Cantidades</Label>
      <div className="grid grid-cols-2 gap-2 mb-2">
        {origFields.map((field) => (
          <div key={field.key}>
            <Label className="text-xs mb-1">{field.label}</Label>
            <input
              value={origData[field.key]}
              onChange={(e) => handleOrigChange(e, field.key)}
              className="w-full p-2 rounded-md border"
              type="number"
              min="0"
              placeholder="0"
            />
          </div>
        ))}
      </div>

      <Label className={`my-0 mt-2`}>Fech.Recep.</Label>
      <input
        value={values.Description2}
        onChange={handleChangeInp}
        className="w-full p-2 rounded-md"
        type="date"
        name="Description2"
      />

      <Label className={`my-0 mt-2`}>Observación</Label>
      <div className="flex gap-2">
        <input
          value={values.Description3}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name="Description3"
        />
        <Button
          disabled={load}
          onClick={handleSubmit}
          className="px-3 py-0 flex items-center gap-2"
        >
          {load ? <Circle /> : "Guardar"}
        </Button>
      </div>
    </form>
  );
};

export default InputDocumentsDataAdd;
